import { render } from "./SinistroCobrancaDetalheView.vue?vue&type=template&id=307476e3&scoped=true"
import script from "./SinistroCobrancaDetalheView.vue?vue&type=script&lang=js"
export * from "./SinistroCobrancaDetalheView.vue?vue&type=script&lang=js"

import "./SinistroCobrancaDetalheView.vue?vue&type=style&index=0&id=307476e3&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307476e3"]])

export default __exports__